import { Link } from 'react-router-dom';

const entries = [
  {
    slug: 'news',
    name: '新闻资讯',
    desc: '财经 · 科技 · 社会 · 健康',
    icon: 'ri-newspaper-line',
    tone: 'bg-primary-500',
    count: '10 篇更新',
  },
  {
    slug: 'life',
    name: '生活服务',
    desc: '家政 · 维修 · 搬家 · 陪护',
    icon: 'ri-home-smile-2-line',
    tone: 'bg-accent-500',
    count: '9 项服务',
  },
  {
    slug: 'entertainment',
    name: '娱乐内容',
    desc: '影视 · 音乐 · 游戏 · 综艺',
    icon: 'ri-movie-2-line',
    tone: 'bg-secondary-600',
    count: '9 条内容',
  },
];

export default function QuickEntries() {
  return (
    <section className="mx-auto mt-8 max-w-[1440px] px-4 md:mt-10 md:px-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {entries.map((e) => (
          <Link
            key={e.slug}
            to={`/category/${e.slug}`}
            className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
          >
            <span className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-lg ${e.tone} text-background-50`}>
              <i className={`${e.icon} text-2xl`}></i>
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {e.name}
                </h3>
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-700">{e.count}</span>
              </div>
              <p className="mt-1 text-xs text-secondary-500">{e.desc}</p>
            </div>
            <i className="ri-arrow-right-line text-secondary-400 transition-transform group-hover:translate-x-1 group-hover:text-primary-500"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}